var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.services.length)?_c('div',{staticClass:"service-item-content__projects"},[_c('h2',{staticClass:"projects-tabs__title"},[_vm._v("Другие услуги")]),_c('div',{staticClass:"service-item-content__projects-blocks"},_vm._l((_vm.services),function(item,i){return _c('ServicePageCardComponent',{key:i,attrs:{"data":item}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }